// PolitiqueCookies.jsx
// À intégrer dans la Vitrine_v5.jsx de SecoursPros
// Usage : remplacer le contenu de la modal "cookies" par <PolitiqueCookies />

const DATE = "14 avril 2026";
const EMAIL = "contact@secourspros.fr";

const cookiesNecessaires = [
  { nom: "sb-access-token", finalite: "Authentification de la session utilisateur", duree: "Session" },
  { nom: "sb-refresh-token", finalite: "Renouvellement automatique de la session", duree: "30 jours" },
  { nom: "theme-preference", finalite: "Mémorisation du mode sombre ou clair", duree: "1 an" },
  { nom: "pwa-install-dismissed", finalite: "Mémorisation du refus d'installation PWA", duree: "1 an" },
];

const cookiesAudience = [
  { nom: "_ga, _gid", finalite: "Analyse du trafic (Google Analytics) — anonymisé", duree: "13 mois max" },
];

export default function PolitiqueCookies() {
  return (
    <div className="pc-cookies">
      <style>{`
        .pc-cookies {
          max-width: 780px;
          margin: 0 auto;
          padding: 1rem 0.5rem 2rem;
          font-family: 'Segoe UI', system-ui, sans-serif;
          color: #1a1a2e;
          font-size: 0.9rem;
          line-height: 1.7;
        }
        .pc-cookies h2 {
          font-size: 1rem;
          font-weight: 700;
          color: #1a3a6b;
          margin: 1.5rem 0 0.5rem;
          padding-bottom: 4px;
          border-bottom: 2px solid #e8f0fe;
        }
        .pc-cookies p { margin: 0.5rem 0; color: #333; }
        .pc-cookies a { color: #e53935; text-decoration: none; font-weight: 500; }
        .pc-cookies a:hover { text-decoration: underline; }
        .cookie-table {
          width: 100%;
          border-collapse: collapse;
          margin: 0.75rem 0 1rem;
          font-size: 0.83rem;
        }
        .cookie-table th {
          background: #1a3a6b;
          color: #fff;
          padding: 0.45rem 0.75rem;
          text-align: left;
          font-weight: 600;
        }
        .cookie-table td {
          padding: 0.45rem 0.75rem;
          border-bottom: 1px solid #e8f0fe;
          vertical-align: top;
        }
        .cookie-table tr:last-child td { border-bottom: none; }
        .cookie-table tr:nth-child(even) td { background: #f5f8ff; }
        .badge-necessaire {
          display: inline-block;
          background: #e8f5e9;
          color: #2e7d32;
          font-size: 0.75rem;
          font-weight: 600;
          padding: 2px 8px;
          border-radius: 20px;
          margin-bottom: 6px;
        }
        .badge-audience {
          display: inline-block;
          background: #fff3e0;
          color: #e65100;
          font-size: 0.75rem;
          font-weight: 600;
          padding: 2px 8px;
          border-radius: 20px;
          margin-bottom: 6px;
        }
        .info-box {
          background: #eef4ff;
          border-left: 4px solid #e53935;
          border-radius: 0 8px 8px 0;
          padding: 0.75rem 1rem;
          margin: 0.75rem 0;
          font-size: 0.87rem;
          color: #1a3a6b;
        }
        .gestion-list {
          padding-left: 1.25rem;
          margin: 0.5rem 0;
        }
        .gestion-list li { margin-bottom: 0.4rem; }
        .pc-footer-note {
          margin-top: 1.5rem;
          padding-top: 1rem;
          border-top: 1px solid #e0e8f5;
          font-size: 0.8rem;
          color: #999;
          text-align: center;
        }
        @media (max-width: 600px) {
          .cookie-table { font-size: 0.78rem; }
          .cookie-table th, .cookie-table td { padding: 0.35rem 0.5rem; }
        }
      `}</style>

      <div className="info-box">
        Un cookie est un petit fichier déposé sur votre appareil lors de votre visite. Il permet à l'application de mémoriser certaines informations pour améliorer votre expérience.
      </div>

      {/* Cookies nécessaires */}
      <h2>Cookies strictement nécessaires</h2>
      <span className="badge-necessaire">Pas de consentement requis</span>
      <p>Ces cookies sont indispensables au fonctionnement de l'application. Sans eux, vous ne pouvez pas vous connecter ni utiliser le service.</p>
      <table className="cookie-table">
        <thead>
          <tr>
            <th>Cookie</th>
            <th>Finalité</th>
            <th>Durée</th>
          </tr>
        </thead>
        <tbody>
          {cookiesNecessaires.map((c) => (
            <tr key={c.nom}>
              <td><code style={{ fontSize: "0.8rem", background: "#f0f4ff", padding: "1px 4px", borderRadius: 4 }}>{c.nom}</code></td>
              <td>{c.finalite}</td>
              <td>{c.duree}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Cookies audience */}
      <h2>Cookies de mesure d'audience</h2>
      <span className="badge-audience">Consentement requis</span>
      <p>Ces cookies nous permettent d'analyser le trafic pour améliorer le service. Ils ne sont déposés qu'après votre accord explicite.</p>
      <table className="cookie-table">
        <thead>
          <tr>
            <th>Cookie</th>
            <th>Finalité</th>
            <th>Durée</th>
          </tr>
        </thead>
        <tbody>
          {cookiesAudience.map((c) => (
            <tr key={c.nom}>
              <td><code style={{ fontSize: "0.8rem", background: "#f0f4ff", padding: "1px 4px", borderRadius: 4 }}>{c.nom}</code></td>
              <td>{c.finalite}</td>
              <td>{c.duree}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Gestion */}
      <h2>Comment gérer vos cookies ?</h2>
      <ul className="gestion-list">
        <li>Depuis la bannière de gestion des cookies (bouton en bas de page)</li>
        <li>Depuis les paramètres de votre navigateur : <strong>Paramètres &gt; Confidentialité &gt; Cookies</strong></li>
        <li>Via des extensions dédiées (ex. : uBlock Origin)</li>
      </ul>
      <p style={{ color: "#c62828", fontSize: "0.85rem" }}>
        ⚠️ La désactivation des cookies nécessaires rendra l'application inutilisable.
      </p>

      {/* Durées */}
      <h2>Durées de conservation</h2>
      <ul className="gestion-list">
        <li><strong>Cookies de session :</strong> supprimés à la fermeture du navigateur</li>
        <li><strong>Cookies persistants :</strong> 13 mois maximum</li>
        <li><strong>Consentement mémorisé :</strong> 6 mois</li>
      </ul>

      <div className="pc-footer-note">
        Questions ? <a href={`mailto:${EMAIL}`}>{EMAIL}</a> — Dernière mise à jour : {DATE}
      </div>
    </div>
  );
}
